/**
 * Dropdown for selecting multiple locations.
 */
import { useData } from '../../hooks/useData';
import type { Location } from '../../types/Location';

import DropdownFilter from './DropdownFilter';

export default function DropdownLocationMultiple({
  dataCy = 'dropdown-location-multiple',
  disabled = false
}: {
  dataCy?: string;
  disabled: boolean;
}): JSX.Element {
  const {
    displayedLocations,
    selectedLocations,
    handleSelectedLocationsChange,
    handleFilter,
    handleSelectAll,
    handleDeselectAll,
  } = useData();

  const naturalSortOptions = (options: Array<{ id: string; value: string }>) => {
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    return [...options].sort((a, b) => collator.compare(a.value, b.value));
  };

  return (
    <DropdownFilter
      disabled={disabled}
      title={`${selectedLocations.length} Locations`}
      options={naturalSortOptions(
        displayedLocations.map((location: Location) => ({
          id: location.id,
          value: location.displayName,
        }))
      )}
      selected={selectedLocations.map((location) => ({
        id: location.id,
        value: location.displayName,
      }))}
      handleChange={handleSelectedLocationsChange}
      filterFunction={handleFilter}
      selectAllFunction={handleSelectAll}
      deselectAllFunction={handleDeselectAll}
      dataCy={dataCy}
    />
  );
}
